import { SimpleGrid, Text, Box, HStack } from '@chakra-ui/react'
import React from 'react'
import { useLocation } from 'react-router-dom';
import { image } from '../config';
import { Link } from 'react-router-dom';

export default function Products() {

    const { state } = useLocation();

    return (
        <>
            {/* <div>{JSON.stringify(state)}</div> */}

            <SimpleGrid columns={[3, 3, 6, 6]} w='100%' p='3' spacing='4'>
                {state.data.map((value) => (
                    <Box
                        as={Link}
                        to={`/scan?item=${value['Item_No']}`}
                        aspectRatio={1 / 1}
                        display='flex'
                        flexDirection='column'
                        justifyContent='flex-end'
                        alignItems='center'
                        p='4'
                        key={value['id']}
                    >
                        <img src={`${image}/${value['stleNO']}.jpg`} />
                        <Text fontSize='xs'>{value['Item_No']}</Text>
                        <Text fontSize='sm'>{value['fsp'] == null ? "" : `Rs ${Math.round(value['fsp'])}`}</Text>
                        <HStack w='100%' bg='red'>
                        </HStack>
                    </Box>
                ))}
            </SimpleGrid>
        </>
    )
}
